import { render, staticRenderFns } from "./InvestmentsInvestikaAccount.vue?vue&type=template&id=5902a229&scoped=true"
import script from "./InvestmentsInvestikaAccount.vue?vue&type=script&lang=js"
export * from "./InvestmentsInvestikaAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5902a229",
  null
  
)

export default component.exports